// src/App.js

import './assets/styles/bootstrap.min.css'; // Bootstrap CSS
import './assets/styles/animate.css'; // Animations
import './assets/styles/personalized.css'; // Custom personalized styles
import './assets/styles/style.css'; // Main style
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './assets/styles/a11y-overrides.css';

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Layout from './components/Layout';

import Home from './pages/home';
import BOD from './pages/bod';
import About from './pages/about';
import Change from './pages/change';
import ContactUs from './pages/contact';
import DonateUs from './pages/donate';
import FAQ from './pages/faq';
import Gallery from './pages/gallery';
import Downloads from './pages/Downloads.js';
import BecomeMember from './pages/becomeMember.js';
import Notices from './pages/notices.js';
import OtherPrograms from './pages/otherPrograms.js';

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/bod" element={<Layout><BOD /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/cbwc" element={<Layout><Change /></Layout>} />
          <Route path="/contact" element={<Layout><ContactUs /></Layout>} />
          <Route path="/donate" element={<Layout><DonateUs /></Layout>} />
          <Route path="/faqs" element={<Layout><FAQ /></Layout>} />
          <Route path="/downloads" element={<Layout><Downloads /></Layout>} />
          <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
          <Route path="/membership" element={<Layout><BecomeMember /></Layout>} />
          <Route path="/notices" element={<Layout><Notices /></Layout>} />
          <Route path="/programs" element={<Layout><OtherPrograms /></Layout>} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
